import { render, staticRenderFns } from "./LichSuDichVuGiaiTriForm.vue?vue&type=template&id=be30e934&scoped=true"
import script from "./LichSuDichVuGiaiTriForm.vue?vue&type=script&lang=js"
export * from "./LichSuDichVuGiaiTriForm.vue?vue&type=script&lang=js"
import style0 from "./LichSuDichVuGiaiTriForm.vue?vue&type=style&index=0&id=be30e934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be30e934",
  null
  
)

export default component.exports